<template>
  <InsuranceSelectionRedesign
    v-if="featureFlagStore.flags.insuranceSelectionRedesign"
    :entered-at="enteredAt"
  />
  <InsuranceSelection
    v-else
    :entered-at="enteredAt"
  />
</template>

<script setup>
// Picks the insurance selection variant of the insuranceSelectionRedesign A/B
// test. The build ships one JavaScript file (codeSplitting: false in
// vite.config.js), so both variants arrive together and the load-time event
// measures each variant's own work from when the route starts rendering.
import InsuranceSelection from '@eu/app/views/InsuranceSelection.vue'
import InsuranceSelectionRedesign from '@eu/app/views/InsuranceSelectionRedesign.vue'
import useFeatureFlagStore from '@shared/stores/useFeatureFlagStore'

const featureFlagStore = useFeatureFlagStore()
const enteredAt = performance.now()
</script>
